// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2PfQc","footer":"ReportModalFilter_footer__2ExQx"};